import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { IARRte } from '../../../Shared/iar-rte'
import './Recruitment.scss'
import { FaRegCheckCircle } from 'react-icons/fa'
import { cloneDeep } from 'lodash'
import ChooseImage from '../../../Shared/ChooseImage'
import ChooseVideo from '../../../Shared/ChooseVideo'
import OnlineVideos from '../../../Shared/OnlineVideos'
import CustomDropdown from '../../../Shared/Dropdown/dropdown'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import MediaThumbnail from '../../../Shared/MediaThumbnail/MediaThumbnail'
import MediaFilesMessage from '../../../Shared/MediaFilesMessage'
import { CustomSwitch } from '../../../Shared/Switch/switch'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import RecruitmentActions from './RecruitmentActions'
import { GetHeaderWithToken } from '../../../../../resources/Utils'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { videoTypes } from '../../../../Constants/videoTypes'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useCMSContext } from './../../CMSContext'
import serviceBase from '../../../../Services/serviceBase'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import { saveSectionVideoProcess } from 'app/Services/serviceSectionsMediaShared'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import { entitySetter } from './recruitmentFunctions'
import { EmptyTagsTypes } from 'app/Constants/bodyTextValidationsTypes'
import PreviewContentLabel from 'app/Components/Shared/PreviewContentLabel/PreviewContentLabel'

const INITIAL_STATE = {
  sectionActive: false,
  sectionName: 0,
  sectionDescription: '',
  bodyText: '',
  positionFiles: 0,
  postMessage: '',
  images: [],
  onlineVideos: [],
  videos: [],
  _id: ''
}

function Recruitment({ fireDepartment }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const cmsContext = useCMSContext()
  const { socket, isReadOnlyMember, newVideoEncoding, iarMember, appConfiguration } =
    cmsContext.state
  const [recruitmentEntity, setRecruitmentEntity] = useState(INITIAL_STATE)
  const [recruitmentEntityDiscard, setRecruitmentEntityDiscard] = useState(INITIAL_STATE)

  Interceptor.interceptor(errorSnackBarActions)

  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [videos, setVideos] = useState([]) // this images is the one to be send in post
  const [onlineVideos, setOnlineVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [posting, setPosting] = useState(false)
  const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)
  const [deletedFiles, setDeletedFiles] = useState([])
  const [updatedFiles, setUpdatedFiles] = useState([])
  const [errorLabel, setErrorLabel] = useState('')
  const [dialog, setDialog] = useState({ open: false })
  const [isDiscarded, setDiscarded] = useState(false)
  const [errorBodyText, setErrorBodyText] = useState('')
  const [disabledButton, setDisabledButton] = useState(true)
  const menuSectionContext = useMenuSectionContext()
  const [deletedSeconds, setDeletedSeconds] = useState([])
  const [showPublishedContent, setShowPublishedContent] = useState(true)

  //Properties for preview
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
  const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
  const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)
  //end properties for preview

  const previewedContentRef = useRef(INITIAL_STATE)
  const publishedContentRef = useRef(INITIAL_STATE)
  const previewDiscardContentRef = useRef(INITIAL_STATE)

  const [bodyText, setBodyText] = useState('')

  useEffect(() => {
    setBodyText(recruitmentEntity.bodyText || '')
  }, [recruitmentEntity._id, recruitmentEntity.bodyText])

  const { setRecruitmentName } = menuSectionContext.actions
  const listOfRecruitmentName = [
    { value: 0, text: 'Recruitment' },
    { value: 1, text: 'Join Now' },
    { value: 2, text: 'Join Us' }
  ]
  const innerRecruitmentChannelName = `${fireDepartment.fireDepartmentId.toString()}_inner_recruitment`

  const isNewVideoEncodingProcessActive = useMemo(() => {
    return (
      newVideoEncoding &&
      videos?.some((x) => !recruitmentEntityDiscard.videos.some((v) => v.fileName === x.fileName))
    )
  }, [newVideoEncoding, videos, recruitmentEntityDiscard.videos])

  const getRecruitmentContent = useCallback(async () => {
    let previewed = INITIAL_STATE
    const published =
      (await RecruitmentActions.getRecruitment(fireDepartment.identifier)) ?? INITIAL_STATE
    if (appConfiguration.previewEnabled) {
      previewed =
        (await RecruitmentActions.getRecruitmentPreview(fireDepartment.identifier)) ?? INITIAL_STATE
    }
    if (!published) {
      setLoading(false)
      return { published: INITIAL_STATE, previewed: INITIAL_STATE }
    }
    let response = !appConfiguration.previewEnabled || showPublishedContent ? published : previewed
    if (response) {
      setRecruitmentEntity(response)
      setRecruitmentEntityDiscard(cloneDeep(response))
      entitySetter(response, setImages, setVideos, setOnlineVideos)
    }
    setLoading(false)
    return { previewed, published }
  }, [appConfiguration.previewEnabled, fireDepartment.identifier, showPublishedContent])

  useEffect(() => {
    ;(async function () {
      if (fireDepartment?.identifier) {
        const { previewed, published } = await getRecruitmentContent()
        previewedContentRef.current = previewed
        publishedContentRef.current = published
        previewDiscardContentRef.current = cloneDeep(previewed)
        if (!appConfiguration.previewEnabled) setShowPublishedContent(true)
      } else {
        setLoading(false)
      }
    })()
  }, [appConfiguration.previewEnabled, fireDepartment.identifier, getRecruitmentContent])

  useEffect(() => {
    if (!showPublishedContent && appConfiguration.previewEnabled) {
      setRecruitmentEntity(previewedContentRef.current)
      setRecruitmentEntityDiscard(cloneDeep(previewDiscardContentRef.current))
      entitySetter(previewedContentRef.current, setImages, setVideos, setOnlineVideos)
    } else {
      setRecruitmentEntity(publishedContentRef.current)
      setRecruitmentEntityDiscard(cloneDeep(publishedContentRef.current))
      entitySetter(publishedContentRef.current, setImages, setVideos, setOnlineVideos)
    }
  }, [appConfiguration.previewEnabled, showPublishedContent])

  useEffect(() => {
    setDisabledButton(posting || (appConfiguration?.previewEnabled && showPublishedContent))
  }, [appConfiguration.previewEnabled, posting, showPublishedContent])

  const processErrorMessageFromSocket = useCallback(
    (args) => {
      setErrorLabel(args.message)

      errorSnackBarActions.setOpen(true, errorLabel)
    },
    [errorLabel, errorSnackBarActions]
  )

  const callbackSuccessForPreview = () => {
    setPosting(false)
  }

  useEffect(() => {
    if (socket) {
      socket.on(innerRecruitmentChannelName, (args) => {
        console.log('CMS_inner_recruitment', args, new Date())
        if (args.action === 'start') {
          setDisabledButton(true)
        }
        if (args.action === 'error') {
          processErrorMessageFromSocket(args)
          setPosting(false)
        }
        if (args.action === 'saved') {
          setDataPosted({ posted: true, message: 'Saved' })
          setPosting(false)
          if (args.response && args.memberId === iarMember.memberId) {
            previewDiscardContentRef.current = cloneDeep(args.response)

            if (args.isPreview) {
              previewedContentRef.current = args.response
            } else {
              publishedContentRef.current = args.response
            }

            //XOR validation
            //applies when show showPublishedContent is false and args.isPreview are true
            //applies when show showPublishedContent is true and args.isPreview are false
            if (!showPublishedContent === Boolean(args.isPreview)) {
              setRecruitmentEntity(args.response)
              setRecruitmentEntityDiscard(cloneDeep(args.response))
              entitySetter(args.response, setImages, setVideos, setOnlineVideos)
            }
            setLoading(false)
          }
        }
      })
    }
    return () => {
      socket.off(innerRecruitmentChannelName)
    }
  }, [
    socket,

    innerRecruitmentChannelName,

    showPublishedContent,

    iarMember.memberId,

    processErrorMessageFromSocket
  ])

  useEffect(() => {
    if (errorLabel !== '') {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel, errorSnackBarActions])

  const handleChange = useCallback((evt) => {
    const value = evt.target.value
    setRecruitmentEntity((entity) => ({
      ...entity,
      [evt.target.name]: value
    }))
  }, [])

  const rteChangeHandler = (content) => {
    setBodyText(content.trim())
  }

  const renderSavedMessage = useCallback(() => {
    if (dataPosted.posted) {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }, [dataPosted])

  const removeOnlineVideo = (file) => {
    const files = deletedFiles

    files.push(file)
    const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
    setOnlineVideos(tempOnlineVideos)
  }

  const removeAsset = (file, type) => {
    const files = deletedFiles
    const secondsDeleted = deletedSeconds
    switch (type) {
      case 'image':
        if (!file.isNew) {
          files.push(file.fileName)
          setDeletedFiles(files)
        }
        const tempImages = images.filter((i) => i.fileName !== file.fileName)
        setImages(tempImages)
        break
      case 'video':
        if (!file.isNew) {
          files.push(file.fileName)
          secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
          setDeletedFiles(files)
          setDeletedSeconds(secondsDeleted)
        }
        const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
        setVideos(tempVideos)
        break
      default:
        break
    }
  }

  const updateAsset = (file) => {
    let tempUpdatedFiles = updatedFiles
    if (tempUpdatedFiles.filter((el) => el.fileName === file.fileName).length > 0) {
      tempUpdatedFiles.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
    } else {
      tempUpdatedFiles.push({ caption: file.caption, fileName: file.fileName })
    }
    setUpdatedFiles(tempUpdatedFiles)
  }

  const sendRecruitment = () => {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    const readyToSave = isReadyToSave()

    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }

    const headers = GetHeaderWithToken()
    let videoPayload = []
    if (recruitmentEntity.videos?.length > 0) {
      videos
        .filter(
          (video) => !recruitmentEntityDiscard.videos.some((x) => x.fileName === video.fileName)
        )
        .forEach((v) => {
          videoPayload.push({
            originalName: v.FileName,
            caption: v.caption,
            type: v.type,
            fileSize: v.fileSize,
            binary: v.binary,
            secondsDuration: v.secondsDuration
          })
        })
    } else {
      videoPayload = videos
    }

    let imagesPayload = []
    if (recruitmentEntity.images?.length > 0) {
      images
        .filter(
          (image) => !recruitmentEntityDiscard.images.some((x) => x.fileName === image.fileName)
        )
        .forEach((v) => {
          imagesPayload.push({
            file: v.file,
            originalName: v.originalName,
            caption: v.caption,
            fileSize: v.fileSize,
            type: v.type
          })
        })
    } else {
      imagesPayload = images
    }

    let onlineVideoPayload = []
    if (recruitmentEntity.onlineVideos && recruitmentEntity.onlineVideos.length > 0) {
      onlineVideos.forEach((v) => {
        onlineVideoPayload.push({
          originalName: v.originalName,
          type: 'online',
          caption: v.caption,
          provider: v.provider,
          fileSize: '',
          url: v.url
        })
      })
    } else {
      onlineVideoPayload = onlineVideos
    }

    let url = `${window._env_.COMMUNITY_API_URL}/recruitment`

    const img = []
    imagesPayload.forEach((image) => {
      img.push({
        originalName: image.originalName,
        caption: image.caption,
        type: image.type,
        fileSize: image.fileSize,
        binary: image.file
      })
    })

    const vid = []
    videoPayload.forEach((video) => {
      vid.push({
        originalName: video.originalName || video.FileName,
        caption: video.caption,
        type: video.type,
        fileSize: video.fileSize,
        binary: video.binary,
        secondsDuration: video.secondsDuration
      })
    })

    const online = []
    onlineVideoPayload.forEach((elem) => {
      online.push({
        originalName: elem.originalName,
        caption: elem.caption,
        type: elem.type,
        provider: elem.provider,
        url: elem.url,
        fileSize: elem.fileSize,
        binary: elem.binary
      })
    })

    const data = {
      _id: recruitmentEntity._id || '',
      fireDepartmentIdentifier: fireDepartment.identifier,
      bodyText: bodyText,
      images: img,
      videos: vid,
      onlineVideos: online,
      positionFiles: parseInt(recruitmentEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: updatedFiles,
      sectionActive: recruitmentEntity.sectionActive || false,
      sectionName: parseInt(recruitmentEntity.sectionName),
      sendPushNotification: recruitmentEntity.sendPushNotification,
      deletedSeconds: deletedSeconds
    }

    if (!recruitmentEntity._id) {
      delete data._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    videos.forEach((video) => {
      if (video.binary === undefined) return

      formData.append('videos', video.binary, video.originalName)

      video.binary = null
    })

    images.forEach((image) => {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`, headers)

    serviceBase.post(url, formData).then(
      (response) => {
        setRecruitmentEntity(response.data)
        setRecruitmentEntityDiscard(cloneDeep(response.data))
        if (response.data.images.length > 0) {
          setImages(response.data.images)
        }
        if (response.data.videos.length > 0) {
          setVideos(response.data.videos)
        }
        if (response.data.onlineVideos.length > 0) {
          setOnlineVideos(response.data.onlineVideos)
        }
        setDataPosted({ posted: true, message: 'Saved' })
        setPosting(false)
        setRecruitmentName(
          listOfRecruitmentName.find((el) => el.value === response.data.sectionName).text
        )
        setDeletedSeconds([])
        setDeletedFiles([])
      },
      (err) => {
        setDataPosted({ posted: false, message: 'Error while saving changes' })
        setPosting(false)
        console.log(err)
      }
    )
  }

  //START SEND PREVIEW
  const sendRecruitmentPreview = async () => {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    const readyToSave = isReadyToSave()
    closePreviewDialog()

    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }

    const headers = GetHeaderWithToken()

    const img =
      images
        .filter(
          (image) => !recruitmentEntityDiscard.images.some((x) => x.fileName === image.fileName)
        )
        .map((v) => ({
          originalName: v.originalName,
          caption: v.caption,
          type: v.type,
          fileSize: v.fileSize,
          binary: v.file
        })) ?? []

    const online =
      onlineVideos.map((v) => ({
        originalName: v.originalName,
        type: 'online',
        caption: v.caption,
        provider: v.provider,
        fileSize: '',
        url: v.url,
        binary: v.binary
      })) ?? []

    let url = `${window._env_.COMMUNITY_API_URL}/recruitment`

    const data = {
      fireDepartmentIdentifier: fireDepartment.identifier,
      bodyText: bodyText,
      images: img,
      videos: [],
      onlineVideos: online,
      positionFiles: parseInt(recruitmentEntity.positionFiles),
      filesToDelete: deletedFiles,
      filesToUpdate: updatedFiles,
      sectionActive: recruitmentEntity.sectionActive,
      sectionName: parseInt(recruitmentEntity.sectionName),
      sendPushNotification: recruitmentEntity.sendPushNotification,
      deletedSeconds: deletedSeconds
    }

    if (recruitmentEntity._id) {
      data._id = recruitmentEntity._id
    }

    const formData = new FormData()

    formData.append('request', JSON.stringify(data))

    images.forEach((image) => {
      if (image.file === undefined) return
      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    if (isReadyToSave()) {
      serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}`, headers)
      serviceBase.post(`${window._env_.COMMUNITY_API_URL}/recruitment-preview`, formData).then(
        (response) => {
          setDataPosted({ posted: true, message: 'Saved' })
          setDeletedSeconds([])
          setDeletedFiles([])
          closePreviewDialog()
        },
        (error) => {
          setDataPosted({ posted: false, message: 'Error while saving changes' })
          setPosting(false)
          setErrorLabel('Error while saving changes')
          errorSnackBarActions.setOpen(true, errorLabel)
          closePreviewDialog()
          console.log(error)
        }
      )
    }
  }
  //END SENDPREVIEW

  const sectionActiveChange = useCallback(() => {
    setRecruitmentEntity((entity) => ({
      ...entity,
      sectionActive: !entity.sectionActive
    }))
  }, [])

  const openConfirmationDialog = () => {
    setDialog({ open: true })
  }

  const cancelDialog = () => {
    setDialog({ open: false })
  }

  const discardChanges = () => {
    setIsDiscardedMedia((prev) => !prev)
    setDialog({ open: false })
    const entity = cloneDeep(recruitmentEntityDiscard)
    setRecruitmentEntity(entity)
    setImages(entity.images)
    setVideos(entity.videos)
    setOnlineVideos(entity.onlineVideos)
    setDeletedFiles([])
    setDiscarded((prevState) => !prevState)
  }

  const closeDiscardDialog = () => {
    setIsDiscardDialogOpen(false)
  }

  const openDiscardDialog = () => {
    setIsDiscardDialogOpen(true)
  }

  const isReadyToSave = () => {
    const richText = bodyText || recruitmentEntity.bodyText
    if (!richText || EmptyTagsTypes.EmptyTag.includes(richText)) {
      setErrorBodyText('This field is required!')
      setPosting(false)
      setDisabledButton(false)
      setTimeout(() => {
        setErrorBodyText('')
      }, 5000)
      return false
    }
    return true
  }

  const getRecruitmentData = (isPreview) => {
    const data = {
      identifier: fireDepartment.identifier,
      richText: bodyText,
      images: processAndGetImages(),
      onlineVideos: processAndGetOnlineVideos(),
      positionFiles: parseInt(recruitmentEntity.positionFiles),
      deletedFiles: deletedFiles,
      updatedFiles: updatedFiles,
      sectionActive: recruitmentEntity?.sectionActive ?? false,
      deletedSeconds: deletedSeconds,
      sectionName: recruitmentEntity.sectionName,
      type: isPreview ? EncondingSectionType.RecruitmentPreview : EncondingSectionType.Recruitment,
      socketChannels: [
        innerRecruitmentChannelName,
        `${fireDepartment.fireDepartmentId.toString()}_recruitment`
      ],
      memberId: iarMember.memberId,
      fireDepartmentId: fireDepartment.fireDepartmentId,
      timezone: fireDepartment.timezone,
      iarMemberFullName: iarMember.fullName,
      contentId: recruitmentEntity._id,
      title: recruitmentEntity.sectionName
    }

    return data
  }

  const emitSocketMessage = async () => {
    serviceBase.get(
      `${window._env_.COMMUNITY_API_URL}/socket-start/emit-start/${fireDepartment.fireDepartmentId}/section-name/recruitment`,
      GetHeaderWithToken()
    )
  }

  const processAndGetImages = () => {
    let imagesPayload = []

    if (recruitmentEntity.images) {
      images.forEach((image) => {
        let fileExists = !recruitmentEntityDiscard.images.some(
          (img) => img.fileName === image.fileName
        )

        if (fileExists) {
          imagesPayload.push({
            file: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else {
      imagesPayload = images
    }
    return imagesPayload
  }

  const processAndGetVideos = () => {
    let videosPayload = []

    if (recruitmentEntity.videos) {
      videos.forEach((video) => {
        if (video.binary) {
          videosPayload.push({
            originalName: video.FileName,
            caption: video.caption,
            type: video.type,
            fileSize: video.fileSize,
            binary: video.binary,
            secondsDuration: video.secondsDuration
          })
        }
      })
    } else {
      videosPayload = videos
    }
    return videosPayload
  }

  const processAndGetOnlineVideos = () => {
    let onlineVideosPayload = []

    if (recruitmentEntity.onlineVideos) {
      onlineVideos.forEach((v) => {
        onlineVideosPayload.push({
          originalName: v.originalName,
          type: 'online',
          provider: v.provider,
          caption: v.caption,
          fileSize: '',
          url: v.url
        })
      })
    } else {
      onlineVideosPayload = onlineVideos
    }
    return onlineVideosPayload
  }

  const processSectionVideoProcessSaving = async (isPreview) => {
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    closePreviewDialog()
    const readyToSave = isReadyToSave()

    if (!readyToSave) {
      setErrorLabel('Missing Information')
      errorSnackBarActions.setOpen(true, errorLabel)
      return
    }
    // Socket IO
    await emitSocketMessage()

    // Creating payload data
    let data = getRecruitmentData(isPreview)
    //set recruitment name just when is preview turn off
    if (!isPreview) {
      const recruitmentSelected = listOfRecruitmentName.find(
        (el) => el.value === +recruitmentEntity.sectionName
      )
      if (recruitmentSelected) setRecruitmentName(recruitmentSelected.text)
    }

    // Get added videos
    const newVideos = processAndGetVideos()

    // Set number of new videos
    if (newVideos && newVideos.length) data.videosNumber = newVideos.length

    // Saving section video process
    const response = await saveSectionVideoProcess(data, newVideos, images)

    // Section video process response validation
    if (!response.sectionVideoProcessResponse) {
      setDataPosted({ posted: false, message: 'Error while saving changes' })
      callbackSuccessForPreview()
      errorSnackBarActions.setOpen(true)
    }

    // Encoder call response validation
    if (response.encoderErrors && response.encoderErrors.length) {
      setErrorLabel('There was an error uploading these files: ', response.encoderErrors.join(', '))
      errorSnackBarActions.setOpen(true, errorLabel)
    }

    setDeletedSeconds([])
    setDeletedFiles([])
  }

  const switchContent = () => {
    setErrorBodyText('')
    if (!showPublishedContent) {
      previewedContentRef.current = {
        ...recruitmentEntity,
        videos,
        images,
        onlineVideos,
        bodyText
      }
    }
    setShowPublishedContent((prev) => !prev)
    setDiscarded((prevState) => !prevState)
  }

  const publishButtonValidations = () => {
    if (
      JSON.stringify(recruitmentEntity) !== JSON.stringify(recruitmentEntityDiscard) ||
      bodyText !== recruitmentEntityDiscard.bodyText ||
      JSON.stringify(videos) !== JSON.stringify(recruitmentEntity.videos) ||
      JSON.stringify(images) !== JSON.stringify(recruitmentEntity.images) ||
      JSON.stringify(onlineVideos) !== JSON.stringify(recruitmentEntity.onlineVideos)
    ) {
      openNotSavedPreviewDialog()
    } else {
      openSaveDialog()
    }
  }

  const openPreviewDialog = () => {
    setIsPreviewDialogOpen(true)
  }

  const closePreviewDialog = () => {
    setIsPreviewDialogOpen(false)
  }

  const openNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(true)
  }

  const closeNotSavedPreviewDialog = () => {
    setIsPreviewNotSavedDialogOpen(false)
  }
  const openSaveDialog = () => {
    setIsSaveDialogOpen(true)
  }

  const closeSaveDialog = () => {
    setIsSaveDialogOpen(false)
  }

  const publishPost = async () => {
    closeSaveDialog()
    setDataPosted({ ...dataPosted, posted: false })
    setPosting(true)
    const response = await RecruitmentActions.postPublishRecruitment(
      recruitmentEntity.fireDepartmentIdentifier
    )
    if (!response) {
      setErrorLabel('There was an error Publishing Recruitment')
      errorSnackBarActions.setOpen(true, errorLabel)
    }

    publishedContentRef.current = response
    previewDiscardContentRef.current = response
    previewedContentRef.current = response
    setRecruitmentEntity(response)
    setRecruitmentEntityDiscard(cloneDeep(response))
    setImages(response?.images ?? [])
    setVideos(response?.videos ?? [])
    setOnlineVideos(response?.onlineVideos ?? [])

    const recruitmentSelected = listOfRecruitmentName.find(
      (el) => el.value === +response.sectionName
    )

    if (recruitmentSelected) setRecruitmentName(recruitmentSelected.text)

    setDataPosted({ posted: true, message: 'Saved' })
    setDeletedSeconds([])
    setDeletedFiles([])
    console.log('POST Recruitment: ', response)

    callbackSuccessForPreview()
  }

  return (
    <div className="recruitment">
      <IARDialog
        open={isPreviewNotSaveDialogOpen}
        title="Save Preview first"
        content="Please save your changes in preview before publishing"
        onOk={closeNotSavedPreviewDialog}
        onCancel={closeNotSavedPreviewDialog}
        previewNotSaved={true}
      />
      <div className="page-header" id="recruitmentTitle">
        Menu Section -{' '}
        {
          listOfRecruitmentName.find(
            (e) => e.value === parseInt(recruitmentEntity.sectionName.toString())
          ).text
        }{' '}
      </div>
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <IARDialog
            open={dialog.open}
            title="Confirm"
            content="Do you want to discard your changes?"
            onOk={discardChanges}
            onCancel={cancelDialog}
          />
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid size={12}>
                <div className="page-description">
                  Let your community members know that you need them, and how they can help! This is
                  an optional page that you can customize to recruit new members for your
                  organization. This is a very important page for any organization that relies on
                  volunteers, as this is the place where you can explain why you need help, ways
                  that community members can help, and any benefits that they might receive for
                  helping. This is where you get to convey your story directly to the community that
                  you need help from. Adding images and short videos can be very helpful here.
                </div>
              </Grid>
              <Grid size={12}>
                <form className="page-content" noValidate autoComplete="off">
                  <Grid container>
                    <Grid size={12} className="container-field">
                      {appConfiguration.previewEnabled && (
                        <div>
                          <span>Display Content as PREVIEW MODE</span>
                          <CustomSwitch
                            name="showPublished"
                            value={!showPublishedContent}
                            sectionActiveChange={switchContent}
                            useYesNoButtons={true}
                          />
                          <PreviewContentLabel
                            showPublished={showPublishedContent}
                            previewEnabled={appConfiguration.previewEnabled}
                          />
                        </div>
                      )}
                      <div>
                        <span>Section Visible on MyLS App</span>
                        <CustomSwitch
                          name="sectionActive"
                          value={Boolean(recruitmentEntity.sectionActive)}
                          sectionActiveChange={sectionActiveChange}
                          disabled={appConfiguration?.previewEnabled && showPublishedContent}
                          useYesNoButtons={true}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <Grid size={12} className="container-field dropdown-container">
                    <div>
                      <label htmlFor="sectionName">Section Name</label> <br />
                      <CustomDropdown
                        name="sectionName"
                        value={recruitmentEntity.sectionName || 0}
                        list={listOfRecruitmentName}
                        onChange={handleChange}
                        disableHandleChange={
                          appConfiguration.previewEnabled && showPublishedContent
                        }
                      />
                    </div>
                  </Grid>
                  <Grid size={12} className="container-field">
                    <label htmlFor="bodyText">Body text</label> <br />
                    <label htmlFor="error" className="error-text">
                      {errorBodyText}
                    </label>
                    <IARRte
                      onChange={rteChangeHandler}
                      content={recruitmentEntity.bodyText}
                      discarded={isDiscarded}
                      disableHandleChange={appConfiguration.previewEnabled && showPublishedContent}
                    />
                  </Grid>
                  <Grid size={12} className="container-field dropdown-container">
                    <div>
                      <label htmlFor="positionFiles">Position images and videos</label> <br />
                      <CustomDropdown
                        name="positionFiles"
                        value={recruitmentEntity.positionFiles || 0}
                        onChange={handleChange}
                        disableHandleChange={
                          appConfiguration.previewEnabled && showPublishedContent
                        }
                      />
                    </div>
                  </Grid>
                  <Grid container>
                    <Grid size={12}>
                      <Grid className="container-field">
                        <label htmlFor="images" className="body-text">
                          Media Files
                        </label>
                        <MediaFilesMessage max={5}></MediaFilesMessage>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseImage
                        images={images}
                        setImages={setImages}
                        fireDepartmentIdentifier={recruitmentEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseImage>
                      <>
                        {images.map((image, index) => (
                          <MediaThumbnail
                            isDiscardedMedia={isDiscardedMedia}
                            type="image"
                            key={[image.fileName, image.caption, index].join('-')}
                            media={image}
                            removeMediaEvent={removeAsset}
                            onUpdate={updateAsset}
                            disableHandleClick={
                              appConfiguration.previewEnabled && showPublishedContent
                            }
                          />
                        ))}
                      </>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} className="media-files">
                      <ChooseVideo
                        videos={videos}
                        setVideos={setVideos}
                        fireDepartmentIdentifier={recruitmentEntity.fireDepartmentIdentifier}
                        max={5}
                        elementsAdded={images.length + videos.length}
                        setErrorLabel={setErrorLabel}
                        isMessageEnabled={false}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      ></ChooseVideo>
                      {videos?.map((video, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="video"
                          key={[video.fileName, video.caption, index].join('-')}
                          media={video}
                          removeMediaEvent={removeAsset}
                          index={index}
                          onUpdate={updateAsset}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                    <Grid size={12} className="media-files">
                      <OnlineVideos
                        videos={onlineVideos}
                        setOnlineVideos={setOnlineVideos}
                        setErrorLabel={setErrorLabel}
                        max={5}
                        disableHandleClick={appConfiguration.previewEnabled && showPublishedContent}
                      />
                      {onlineVideos?.map((onlineVideo, index) => (
                        <MediaThumbnail
                          isDiscardedMedia={isDiscardedMedia}
                          type="online"
                          key={[onlineVideo.fileName, onlineVideo.caption, index].join('-')}
                          media={onlineVideo}
                          removeMediaEvent={removeAsset}
                          index={index}
                          subType={videoTypes.YoutubeVideos}
                          onUpdate={updateAsset}
                          removeOnlineVideo={removeOnlineVideo}
                          disableHandleClick={
                            appConfiguration.previewEnabled && showPublishedContent
                          }
                        />
                      ))}
                    </Grid>
                  </Grid>
                  <Grid size={12} className="container container-buttons">
                    {!appConfiguration?.previewEnabled ? (
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          disabled={isReadOnlyMember || disabledButton}
                          loading={posting}
                          onClickCallback={
                            isNewVideoEncodingProcessActive
                              ? () => processSectionVideoProcessSaving(false)
                              : sendRecruitment
                          }
                        />
                        <Button
                          style={{ maxWidth: '250px', minWidth: '250px' }}
                          variant="outlined"
                          id="cancelButtonEntity"
                          disabled={isReadOnlyMember || disabledButton}
                          color="primary"
                          size="medium"
                          onClick={openConfirmationDialog}
                        >
                          Discard
                        </Button>
                        <div>{renderSavedMessage()}</div>
                      </div>
                    ) : (
                      <PrepublishButtons
                        isDiscardDialogOpen={isDiscardDialogOpen}
                        isPreviewDialogOpen={isPreviewDialogOpen}
                        isReadOnlyMember={isReadOnlyMember}
                        isShown={appConfiguration.previewEnabled}
                        isSaveDialogOpen={isSaveDialogOpen}
                        openPreviewDialog={openPreviewDialog}
                        openDiscardDialog={openDiscardDialog}
                        closePreviewDialog={closePreviewDialog}
                        closeDiscardDialog={closeDiscardDialog}
                        closeSaveDialog={closeSaveDialog}
                        callbackSuccess={callbackSuccessForPreview} //This prop isn't use
                        discardChanges={discardChanges}
                        disabledButton={disabledButton}
                        publishButtonValidations={publishButtonValidations}
                        posting={posting}
                        savePreview={() => {
                          if (isNewVideoEncodingProcessActive)
                            processSectionVideoProcessSaving(true)
                          else sendRecruitmentPreview()
                        }}
                        savePublish={publishPost}
                      />
                    )}
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  )
}

export default Recruitment
